import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Instagram } from "lucide-react";
import { NAV, BRAND } from "../data/site";

export default function Navbar() {
  const [open, setOpen] = React.useState(false);
  return (
    <header className="sticky top-0 z-50 border-b-2 border-ink bg-cream" data-testid="site-header">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 md:px-10">
        <Link to="/" className="flex items-center" onClick={() => setOpen(false)} data-testid="nav-logo" aria-label="RMorrison home">
          <img
            src="/brand/rmorrison-logo.png"
            alt="RMorrison"
            className="h-10 md:h-12 w-auto select-none"
            draggable={false}
            width={3576}
            height={1456}
          />
        </Link>
        <nav className="hidden gap-8 md:flex" aria-label="Primary">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              className={({ isActive }) =>
                `eyebrow text-[0.72rem] transition-colors ${isActive ? "text-coral" : "text-ink hover:text-coral"}`
              }
              data-testid={`nav-link-${n.label.toLowerCase().replace(/\s+/g,'-')}`}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a href={BRAND.instagram} target="_blank" rel="noreferrer" className="hidden md:inline-flex" aria-label="Instagram" data-testid="nav-instagram">
            <Instagram className="h-5 w-5 text-ink hover:text-coral transition-colors" />
          </a>
          <Link to="/contact" className="btn-brut hidden md:inline-flex" data-testid="nav-enquire">Enquire</Link>
          <button onClick={() => setOpen(!open)} className="md:hidden p-2" aria-label="Menu" data-testid="mobile-menu-toggle">
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>
      {open && (
        <div className="md:hidden border-t-2 border-ink bg-cream" data-testid="mobile-menu">
          <div className="flex flex-col px-5 py-4 gap-3">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `eyebrow text-sm py-2 ${isActive ? "text-coral" : "text-ink"}`
                }
                data-testid={`mobile-nav-link-${n.label.toLowerCase().replace(/\s+/g,'-')}`}
              >
                {n.label}
              </NavLink>
            ))}
            <Link to="/contact" onClick={() => setOpen(false)} className="btn-brut mt-2" data-testid="mobile-enquire-btn">Enquire now</Link>
          </div>
        </div>
      )}
    </header>
  );
}
